/* eslint-disable react/no-unused-prop-types */
const PropTypes = require('prop-types');

/** @type {import('../../melidata-track').MelidataTrack} */
const MelidataTrack = () => null;

MelidataTrack.propTypes = {
  path: PropTypes.string.isRequired,
  id: PropTypes.string,
  event_data: PropTypes.shape({}),
  application: PropTypes.shape({}),
  device: PropTypes.shape({}),
  user: PropTypes.shape({}),
  platform: PropTypes.shape({ http: PropTypes.shape({}).isRequired }),
  type: PropTypes.oneOf(['view', 'event']),
  isDeferred: PropTypes.bool,
  experiments: PropTypes.shape({}),
  userTime: PropTypes.number,
  userLocalTimeStamp: PropTypes.string,
  lastExperimentsTimeStamp: PropTypes.string,
  technologies: PropTypes.arrayOf(PropTypes.string),
  propertiesToEncrypt: PropTypes.arrayOf(PropTypes.string),
};

MelidataTrack.MelidataTrack = MelidataTrack;

module.exports = MelidataTrack;
